<template>
  <div :style="{ margin: '-8px' }">
    <v-layout align-center>
      <v-flex class="pa-2 headline primary--text">{{ $t('survey') }}</v-flex>
      <v-flex v-if="!isEdit" shrink class="pa-2">
        <v-btn
          icon
          outline
          color="primary"
          :disabled="isLoading"
          class="ma-0"
          @click="isEdit = true"
        >
          <v-icon small>edit</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <div class="pa-2">
      <v-layout fill-height wrap>
        <v-flex xs12 class="mb-4">
          <v-switch
            v-model="closed_with_survey"
            label="Closed with Survey"
            color="primary"
            hide-details
            class="ma-0 pa-0"
            :readonly="!isEdit"
          />
        </v-flex>
        <template v-if="closed_with_survey_message.length < 5 && isEdit">
          <v-flex xs12 class="mb-4">
            <button :disabled="isLoading" class="survey-button__wrapper" @click="showDialog = true">
              <i class="fa fa-plus"></i>
              <span>{{ $t('survey') }}</span>
            </button>
          </v-flex>
        </template>
      </v-layout>
      <SurveyFormDialog ref="surveyForm" v-model="showDialog" @submit="handleSubmitSurvey" />
      <v-layout fill-height wrap>
        <v-flex
          v-for="(survey, index) in closed_with_survey_message"
          :key="`survey_${index}`"
          xs12
          class="mb-3"
        >
          <SurveyCard
            :is-edit="isEdit"
            :message="survey.message"
            :button-name="survey.button_name"
            :survey-id="survey.survey_id"
            :created-at="survey.created_at"
            :updated-at="survey.updated_at"
            :is-default="survey.is_default"
            @edit="handleEdit(index)"
            @delete="handleDeleteSurvey(index)"
          />
        </v-flex>
      </v-layout>
    </div>
    <div v-if="isEdit" class="mt-3">
      <v-layout justify-center wrap>
        <v-flex shrink>
          <v-btn outline color="grey" :disabled="isLoading" @click="isEdit = false">{{
            $t('cancel')
          }}</v-btn>
        </v-flex>
        <v-flex shrink>
          <v-btn depressed color="primary" :disabled="isLoading" @click="handleSubmit">{{
            $t('Save')
          }}</v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import SurveyFormDialog from './SurveyFormDialog.vue'
import SurveyCard from './SurveyCard.vue'
import ticket3PageApi from '@/api/ticket3/page'
import { handleApiError } from '@/api/util'
export default {
  name: 'CustomerSupportServiceSurveySetting',
  components: { SurveyFormDialog, SurveyCard },
  data() {
    return {
      isEdit: false,
      isLoading: false,
      showDialog: false,
      closed_with_survey: false,
      closed_with_survey_message: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    selectedBot(value) {
      const { closed_with_survey, closed_with_survey_message } = value.ticket_v3_config
      this.closed_with_survey = closed_with_survey
      this.closed_with_survey_message = closed_with_survey_message
    }
  },
  mounted() {
    const { closed_with_survey, closed_with_survey_message } = this.selectedBot.ticket_v3_config
    this.closed_with_survey = closed_with_survey
    this.closed_with_survey_message = closed_with_survey_message
  },
  methods: {
    handleSubmitSurvey(data, index) {
      if (data.is_default) {
        this.closed_with_survey_message = this.closed_with_survey_message.map((survey) => {
          return {
            ...survey,
            is_default: false
          }
        })
      }
      if (index !== null && index >= 0) {
        this.$set(this.closed_with_survey_message, index, data)
        return
      }
      this.closed_with_survey_message.push(data)
    },
    handleEdit(index) {
      const selectSurvey = this.closed_with_survey_message[index]
      if (selectSurvey) {
        this.$refs.surveyForm.handleInitData(selectSurvey, index)
      }
    },
    async handleDeleteSurvey(index) {
      const result = await this.$swal({
        title: this.$t('Do you want to delete {name}?', {
          name: this.$t('survey')
        }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        if (index > -1 && this.closed_with_survey_message.length > 0) {
          this.closed_with_survey_message.splice(index, 1)
        }
      }
    },
    async handleSubmit() {
      try {
        this.isLoading = true
        const response = await ticket3PageApi.putTicketConfig({
          data: {
            page_id: this.selectedBot.pageid,
            ticket_config: {
              ...this.selectedBot.ticket_v3_config,
              closed_with_survey: this.closed_with_survey,
              closed_with_survey_message: this.closed_with_survey_message
            }
          }
        })
        if (response.status === 204) {
          await this.$swal.fire({
            title: this.$t('Successfully'),
            type: 'success'
          })
          this.$store.dispatch('updateBotDetail')
        }
      } catch (error) {
        console.error(error)
        await handleApiError(error)
      } finally {
        this.isLoading = false
        this.isEdit = false
      }
    }
  }
}
</script>
<style lang="css" scoped>
.survey-button__wrapper {
  min-height: 64px;
  border-radius: 16px;
  border: 1px dashed #ff846d;
  background: #fff0ee;
  position: relative;
  padding: 16px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  width: 100%;
  color: #ff846d;
}
.survey-button__wrapper:hover {
  opacity: 0.8;
}
</style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/Setting/CustomerSupportService/SurveySetting.vue